export const SET_VISIBLE_POPUP = "SET_VISIBLE_POPUP";
export const SET_SELECTED_POPUP = "SET_SELECTED_POPUP";
export const SET_SELECTED_TOOL = "SET_SELECTED_TOOL";
